"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseLicenseCompactDto = instanceOfNurseLicenseCompactDto;
exports.NurseLicenseCompactDtoFromJSON = NurseLicenseCompactDtoFromJSON;
exports.NurseLicenseCompactDtoFromJSONTyped = NurseLicenseCompactDtoFromJSONTyped;
exports.NurseLicenseCompactDtoToJSON = NurseLicenseCompactDtoToJSON;
exports.NurseLicenseCompactDtoToJSONTyped = NurseLicenseCompactDtoToJSONTyped;
/**
 * Check if a given object implements the NurseLicenseCompactDto interface.
 */
function instanceOfNurseLicenseCompactDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined)
        return false;
    return true;
}
function NurseLicenseCompactDtoFromJSON(json) {
    return NurseLicenseCompactDtoFromJSONTyped(json, false);
}
function NurseLicenseCompactDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
    };
}
function NurseLicenseCompactDtoToJSON(json) {
    return NurseLicenseCompactDtoToJSONTyped(json, false);
}
function NurseLicenseCompactDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
    };
}
//# sourceMappingURL=NurseLicenseCompactDto.js.map